/** Preset checklist templates for the plan wizard. */

export const CHECKLIST_TEMPLATES = {
  empty: {
    id: 'empty',
    label: 'Vuota',
    items: [],
  },
  family: {
    id: 'family',
    label: 'Famiglia (base)',
    items: [
      { itemKey: 'pack-hiking-shoes', label: 'Scarpe da camminata', category: 'valigia' },
      { itemKey: 'pack-rain-jacket', label: 'Giacca antipioggia', category: 'valigia' },
      { itemKey: 'pack-swimsuits', label: 'Costumi + asciugamani', category: 'valigia' },
      { itemKey: 'pack-sunscreen', label: 'Crema solare + cappellini', category: 'valigia' },
      { itemKey: 'pack-bottles', label: 'Borracce', category: 'valigia' },
      { itemKey: 'pack-first-aid', label: 'Kit pronto soccorso', category: 'valigia' },
      { itemKey: 'docs-id', label: 'Documenti validi', category: 'documenti' },
      { itemKey: 'app-maps-offline', label: 'Mappe offline', category: 'app' },
      { itemKey: 'eve-charge', label: 'Carica dispositivi', category: 'giorno-prima' },
    ],
  },
  roadtrip: {
    id: 'roadtrip',
    label: 'Roadtrip',
    items: [
      { itemKey: 'car-vignette', label: 'Vignetta / pedaggi', category: 'auto' },
      { itemKey: 'car-check', label: 'Controllo auto (gomme, olio)', category: 'auto' },
      { itemKey: 'car-safety-kit', label: 'Kit sicurezza auto', category: 'auto' },
      { itemKey: 'car-phone-mount', label: 'Supporto telefono', category: 'auto' },
      { itemKey: 'car-offline-maps', label: 'Mappe offline scaricate', category: 'auto' },
      { itemKey: 'booking-stays', label: 'Alloggi prenotati', category: 'prenotazioni' },
      { itemKey: 'app-maps-offline', label: 'Google Maps offline', category: 'app' },
      { itemKey: 'eve-snacks', label: 'Snack per il viaggio', category: 'giorno-prima' },
    ],
  },
};

export const CHECKLIST_TEMPLATE_LIST = Object.values(CHECKLIST_TEMPLATES);
